import React from "react"
import { Button } from "../../components/Button/Button"
import { useMutation } from "react-query";
import { AuthService } from "../../services/auth.service";
import { FormikProvider, useFormik } from "formik";
import { Asserts, number, object, string } from "yup";
import { TextInput } from "../../components/FormInputs/TextInput";
import { AuthActions } from "../../zustand/auth.store";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";


export const ResetSuccess = () => {
    const navigate = useNavigate();

    const backtoLogin = ()  => setTimeout(() => {
        requestAnimationFrame(() => {
            navigate("/");
         });
    }, 5000);

    React.useEffect(() => {
      backtoLogin()
    }, [])
    
    return (
        <div>
            <div className="card bg-white w-auto rounded-md p-9">
                <div className="flex justify-around">
                    <img
                        src={"/images/pc-logo.svg"}
                        className=""
                        alt="Paycenter_logo"
                    />
                </div>
                <div className="mt-6">
                    <h5 className="text-center font-bold">Password reset confirmed, Check your mail for next steps</h5>
                </div>

                <Button label="Back to login"  className="w-full mt-6"/>
            </div>

        </div>
    )
}